import React from 'react';
import { VertTypography } from '@vertem-core/vertice-ds';
import MenuItemsMobile from 'components/Menu/MenuItemsMobile';

const HeaderMenuDefaultMobile = () => {
  return (
    <>
      <MenuItemsMobile menuType="categoryMenu" />
      <MenuItemsMobile menuType="headerMenu" />
      <VertTypography.Paragraph className="header-mobile-menu-items">
        <a href="/auth/logout">Sair</a>
      </VertTypography.Paragraph>
    </>
  );
};

export default HeaderMenuDefaultMobile;
